import { ValueOf } from 'fym-common/src/types/utilityTypes';
import { RawWidgetData, SmartLinkWidgetType } from 'fym-common/src/db/enums';
import { SerializedWidget } from 'fym-common/src/db/serializersTypes';
import { parseMediaWidgetData } from 'fym-shared/src/smartlinks/mediaWidget';

/**
 * The stored data of a block, read back from its answer: what a PATCH or a new block (Duplicate)
 * sends. Null when the block cannot be copied (a block with a pre-save campaign: a page holds one
 * campaign; a block type this build does not know).
 */
export function rawDataOfWidget(widget: SerializedWidget): ValueOf<RawWidgetData> | null {
  switch (widget.type) {
    case SmartLinkWidgetType.info:
      return { text: widget.data.text, type: widget.data.type };
    case SmartLinkWidgetType.link: {
      const { url, label, smartLinkId } = widget.data;
      return smartLinkId === undefined || smartLinkId === null
        ? { url, label }
        : { url, label, targetSmartLinkId: smartLinkId };
    }
    case SmartLinkWidgetType.player: {
      const { url, embedUrl, type, height, version } = widget.data;
      return { url, embedUrl, type, height, version };
    }
    case SmartLinkWidgetType.socialLinks:
      return { order: widget.data.order, hidden: widget.data.hiddenTypes };
    case SmartLinkWidgetType.profile:
      return {};
    case SmartLinkWidgetType.media: {
      const { source, autoplay, loop, controls, shape, fit, caption, linkUrl } = widget.data;
      return parseMediaWidgetData({ source, autoplay, loop, controls, shape, fit, caption, linkUrl });
    }
    case SmartLinkWidgetType.presave: {
      const { catalogItemUuid, services, hasCampaign } = widget.data;
      if (hasCampaign !== false || catalogItemUuid === undefined || catalogItemUuid === null) {
        return null;
      }
      return { catalogItemUuid, services };
    }
    case SmartLinkWidgetType.presaveSubscribe:
      return { services: widget.data.services };
    case SmartLinkWidgetType.image:
      return widget.data.image === null ? null : { imageId: widget.data.image.id };
    default:
      return null;
  }
}

/** A block the page can hold only once: a second one is never offered (Duplicate, the picker). */
export function isOnceOnlyBlock(widget: SerializedWidget): boolean {
  if (widget.type === SmartLinkWidgetType.presaveSubscribe) {
    return true;
  }
  return widget.type === SmartLinkWidgetType.presave && widget.data.hasCampaign !== false;
}
